import { Entity } from '@backstage/catalog-model';
import { Chip, makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

/**
 * Marks a component whose feature development has stopped (deploys are
 * maintenance-only). Only the literal value "true" enables it. Shared by the
 * MergeOps group view, the entity Overview warning and the catalog table.
 */
export const MERGEOPS_MAINTENANCE_MODE_ANNOTATION =
  'mergeops.kworkinc.com/maintenance-mode';

/** Usable directly as an EntitySwitch.Case `if` predicate. */
export function isMaintenanceMode(entity: Entity): boolean {
  return (
    entity.metadata.annotations?.[MERGEOPS_MAINTENANCE_MODE_ANNOTATION] ===
    'true'
  );
}

const useChipStyles = makeStyles(theme => ({
  chip: {
    margin: 0,
    height: 20,
    fontSize: '0.68rem',
    color: theme.palette.type === 'dark' ? '#fbbf24' : '#b45309',
    borderColor:
      theme.palette.type === 'dark'
        ? 'rgba(251, 191, 36, 0.5)'
        : 'rgba(180, 83, 9, 0.4)',
    backgroundColor:
      theme.palette.type === 'dark'
        ? 'rgba(251, 191, 36, 0.08)'
        : 'rgba(251, 191, 36, 0.12)',
  },
}));

/** Small amber "Maintenance" badge for component lists and headers. */
export const MaintenanceModeChip = () => {
  const classes = useChipStyles();
  return (
    <Chip
      label="Maintenance"
      variant="outlined"
      size="small"
      className={classes.chip}
    />
  );
};

/** Banner for the entity Overview page of a maintenance-mode component. */
export const EntityMaintenanceModeWarning = () => (
  <Alert severity="warning">
    This component is in maintenance mode — feature development is stopped and
    it is hidden from the team's MergeOps view by default (annotation{' '}
    <code>{MERGEOPS_MAINTENANCE_MODE_ANNOTATION}</code>).
  </Alert>
);
